import { SprinklesElement } from "sprinkles-js";

export default class ScrollTopButtonElement extends SprinklesElement {
  static tagName = "scroll-top-button";
  static events = {
    scroll: { method: "handleScroll", element: window },
    click: { method: "handleClick" },
  };

  handleScroll() {
    const threshold = document.documentElement.clientHeight * 0.5;
    this.hidden = window.scrollY < threshold;
  }

  handleClick(event) {
    event.preventDefault();
    window.scrollTo({ top: 0 });
  }
}
